import React from "react";
import { Link } from "react-router-dom";

interface QuickAction {
  path: string | null;
  title: string;
  sub: string;
  iconPath: string;
}

const ACTIONS: QuickAction[] = [
  {
    path: "/chat",
    title: "Ask Strongifier AI",
    sub: "Chat about your training",
    iconPath:
      "M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z",
  },
  {
    path: "/calendar",
    title: "Plan this week",
    sub: "Open your calendar",
    iconPath:
      "M8 2v4M16 2v4M3 10h18M5 4h14a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2z",
  },
  {
    path: null, // opens the manual-workout modal
    title: "Log a manual workout",
    sub: "No device data needed",
    iconPath: "M12 8v8M8 12h8M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0",
  },
];

interface QuickActionsProps {
  onLogWorkout: () => void;
}

export const QuickActions: React.FC<QuickActionsProps> = ({ onLogWorkout }) => {
  return (
    <section className="home__card home__actions">
      <div className="home__card-title">Quick actions</div>
      {ACTIONS.map((action) => {
        const content = (
          <>
            <svg
              width="18"
              height="18"
              viewBox="0 0 24 24"
              fill="none"
              stroke="#f0862f"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <path d={action.iconPath}></path>
            </svg>
            <span className="home__action-text">
              <span className="home__action-title">{action.title}</span>
              <span className="home__action-sub">{action.sub}</span>
            </span>
            <span className="home__action-chevron">›</span>
          </>
        );
        return action.path ? (
          <Link to={action.path} className="home__action" key={action.title}>
            {content}
          </Link>
        ) : (
          <a
            href="#log"
            className="home__action"
            key={action.title}
            onClick={(e) => {
              e.preventDefault();
              onLogWorkout();
            }}
          >
            {content}
          </a>
        );
      })}
    </section>
  );
};
